import wixData from 'wix-data';
import wixWindow from 'wix-window';

$w.onReady(function () {
	if(wixWindow.formFactor === "Mobile"){
		$w('#repeater2').hide()
		.then(() => $w('#repeater2').collapse())
		.then(() => $w('#repeater3').show())
		.then(() => $w('#repeater3').expand())
	} 
	$w('#buttonCSAT').style.backgroundColor = '#A7C2FB';
	filterDataByTheme('CSAT');
});

function filterDataByTheme(themeArr) {
	let myFilter = wixData.filter();
	myFilter = myFilter.contains("theme", themeArr);
	$w("#datasetSpotter").setFilter(myFilter);
	$w("#datasetSpotterMob").setFilter(myFilter);	
}

let activeDayBtn = 1;

export function buttonCSAT_click(event) {
	if(activeDayBtn === 1) return;
	filterDataByTheme('CSAT');
	activeDayBtn = 1;
	$w('#buttonOppEff, #buttonRiskMng, #buttonKB').style.backgroundColor = "#D9E5FF";
	$w('#buttonCSAT').style.backgroundColor = "#A7C2FB";
}


export function buttonOppEff_click(event) {
	if(activeDayBtn === 2) return;
	filterDataByTheme('Operational efficiency');
	activeDayBtn = 2;
	$w('#buttonCSAT, #buttonRiskMng, #buttonKB').style.backgroundColor = "#D9E5FF";
	$w('#buttonOppEff').style.backgroundColor = "#A7C2FB";
}


export function buttonRiskMng_click(event) {
	if(activeDayBtn === 3) return;
	filterDataByTheme('Risk management');
	activeDayBtn = 3;
	$w('#buttonCSAT, #buttonOppEff, #buttonKB').style.backgroundColor = "#D9E5FF";
	$w('#buttonRiskMng').style.backgroundColor = "#A7C2FB";
}

export function buttonKB_click(event) {
	if(activeDayBtn === 4) return;
	filterDataByTheme('KB proactivity');
	activeDayBtn = 4;
	$w('#buttonCSAT, #buttonOppEff, #buttonRiskMng').style.backgroundColor = "#D9E5FF";
	$w('#buttonKB').style.backgroundColor = "#A7C2FB";
}